import {Component, OnInit, Input, Output, EventEmitter, OnChanges} from '@angular/core';
import { EnumModel } from 'app/shared/objects/EnumModel';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.less']
})
export class DropdownComponent implements OnInit {
  @Input() values: EnumModel[];
  @Input() selected: EnumModel;
  @Input() disabled: boolean;
  @Input() showOTDropdown: boolean;
  @Input() showPSDropdown: boolean;
  @Output() showOTDropdownChange = new EventEmitter<boolean>();
  @Output() showPSDropdownChange = new EventEmitter<boolean>();
  @Output() selectedChange = new EventEmitter();

  showOptions = false;

  constructor() {
  }
  ngOnInit() {
  }
  onFocusLost() {
    this.showOptions = false;
    this.showOTDropdownChange.emit(false);
    this.showPSDropdownChange.emit(false);
  }
  toggleOptions() {
    if (!this.disabled) {
      this.showOptions = !this.showOptions;
    } else {
        this.showOptions = false;
        this.showOTDropdownChange.emit(false);
      this.showPSDropdownChange.emit(false);
    }
  }

  selectOption(value) {
    this.selected = value;
    this.selectedChange.emit(this.selected);
    this.showOptions = false;
    this.showOTDropdownChange.emit(false);
    this.showPSDropdownChange.emit(false);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/dropdown/dropdown.component.ts